import axiosClient from "../../../../../system/helpers/axiosConfig";

export const postNotification = (params) => {
  return axiosClient
    .post(`api/admin/notifications/global-notifications`, params)
    .then((r) => r.data.data);
};
